import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteOrganisationLogoRequestType } from '../types';

export const deleteOrganisationLogo = async ({
  pathParams: { organisationId },
}: DeleteOrganisationLogoRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/logo`;
  const { data } = await apiAuthClient.delete<void>(url);
  return data;
};
